module.exports = __webpack_public_path__ + "static/img/pay-es-btn.e8a955e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/pay/pay-es-btn.png
// module id = rDxA
// module chunks = 1